module.exports = __webpack_public_path__ + "static/hats-67c0d9dfdcc46dd34ef3ab78b187f0bb.jpg";